import { FunctionComponent } from "react";
import TabelaConexao from "./tabela";
import HeaderTableConexao from "./header";
import { Container } from "../../../../components/formulario/styled";

interface ContainerProps {

}

const ContainerConexao: FunctionComponent<ContainerProps> = () => {
  return (<>
    <Container>
      <HeaderTableConexao />
      <TabelaConexao />
    </Container>
  </>);
}

export default ContainerConexao;
